import { Fancybox } from '@fancyapps/ui';

class PodcastController {
  constructor() {
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-open-podcast', _this.initPodcast);

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.audio-podcast__close', _this.closePodcast);

    const exceptions = [
      ':not([target="_blank"])',
      ':not([href~="javascript:void(0)"])',
      ':not([data-toggle])',
      ':not([data-fancybox])',
      ':not([href^="#"])',
    ];

    document
      .querySelector('body')
      ._addCustomEventListener('click', 'a' + exceptions.join(''), _this.showWarning);
  }

  initPodcast(e) {
    const { src, title } = e.targetElement.dataset;
    const audio = new Audio(src);
    const audio_html = document.querySelector('.audio-podcast__audio');
    const podcast_html = document.querySelector('#audio-podcast');
    const title_html = document.querySelector('.audio-podcast__title');

    title_html.innerHTML = title;
    audio_html.innerHTML = '';
    audio_html.appendChild(audio);

    const player = new MediaElementPlayer(audio, {
      audioWidth: '100%',
    });

    podcast_html
      ._show()
      .then(() => {
        player.media.play();
      })
      .catch((err) => {
        player.media.play();
      });
  }

  closePodcast() {
    const podcast_html = document.querySelector('#audio-podcast');
    const audio_html = document.querySelector('.audio-podcast__audio audio');

    audio_html.player.media.pause();
    podcast_html._hide();
  }

  showWarning(e) {
    if (e.targetElement.classList.contains('allow-out')) return;

    const audio = document.querySelector('#audio-podcast');

    if (audio && window.getComputedStyle(audio).display !== 'none') {
      e.preventDefault();

	  const podcastWarning = Fancybox.show([
	  	{
	        src: '#podcast-warning',
	        type: 'inline',
	        touch: false
      	}
      ]);
      podcastWarning.on('done',function(){
	      const href =
	            e.targetElement.getAttribute('href') || e.targetElement.find('a').getAttribute('href');
	          document.querySelector('.audio-podcast-warning .button').setAttribute('href', href);
      });
      
    }
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.PodcastController = new PodcastController();
  }
});
